import React from "react";
import { Link } from "react-router-dom";
import { PROGRAMS } from "../components/Header";
import { ArrowRight } from "lucide-react";

const IMAGES = {
    "/programs/pieces-of-hope": "https://images.unsplash.com/photo-1596079890744-c1a0462d0975?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "/programs/purpose-in-the-process": "https://images.unsplash.com/photo-1519834584171-c47ce7e0a687?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "/programs/haven-of-hope": "https://images.unsplash.com/photo-1518398046578-8cca57782e17?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "/programs/gok-second-chance": "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export default function Programs() {
    return (
        <div data-testid="programs-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
            <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24 items-end">
                <div className="md:col-span-7">
                    <div className="eyebrow text-[#B8860B] mb-6">Our Programs</div>
                    <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.95]">
                        Where the <em className="italic">work</em> of kindness lives.
                    </h1>
                </div>
                <div className="md:col-span-5">
                    <p className="text-lg text-black/65 font-light leading-relaxed">
                        Four programs, four communities, one belief: that every person deserves someone in their corner. Learn about each below.
                    </p>
                </div>
            </div>

            <div className="grid md:grid-cols-2 gap-x-10 gap-y-16">
                {PROGRAMS.map((p, i) => (
                    <Link
                        key={p.to}
                        to={p.to}
                        data-testid={`program-card-${p.to.split("/").pop()}`}
                        className="group"
                    >
                        <div className="aspect-[4/3] overflow-hidden bg-black/5 mb-6">
                            {IMAGES[p.to] && (
                                <img
                                    src={IMAGES[p.to]}
                                    alt={p.label}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            )}
                        </div>
                        <div className="eyebrow text-[#B8860B] mb-3">Program {String(i + 1).padStart(2, "0")}</div>
                        <h2 className="font-serif text-3xl md:text-4xl tracking-tight leading-tight group-hover:text-[#B8860B] transition-colors">
                            {p.label}
                        </h2>
                        <p className="text-black/60 mt-3 font-light">{p.sub}</p>
                        <div className="mt-5 inline-flex items-center gap-2 eyebrow text-black/60 group-hover:text-[#B8860B]">
                            Learn more <ArrowRight size={14} />
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
